<template>
  <Transition>
  <div class="modal">
  <div class="video-modal__container">
    <AppButton type="ghost" size="m" @click="closeModal" :with-icon="true" icon-position="center" class="close-modal"><template #left><IconDefault name="menu-close" size="m"></IconDefault></template></AppButton>
    <video class="video" controls autoplay>
      <source src="/img/video/Sminex_SimplePrive.mp4" type="video/mp4">
    </video>
  </div>
  </div>
  </Transition>
</template>

<script setup lang="ts">
import { usePagesStore } from "@stores/pages";
import IconDefault from "@components/AppIcon/index.vue";
import {storeToRefs} from "pinia";
import AppButton from "@components/AppButton/index.vue";

defineOptions({
  name:'ModalVideo'
})

const pagesStore = usePagesStore();
const { showVideo } = storeToRefs(pagesStore);
const closeModal = () => {
  showVideo.value = false;
}

</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    z-index: 15000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--background-primary);
    .video-modal__container{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .close-modal{
        position: absolute;
        top: 1rem;
        right: 1rem;
      }
      .video{
        width: 48.4rem;
        height: 86.2rem;
        @media screen and (max-width:768px)  {
          height: 100%;
          width: auto;
        }
      }
    }
  }
</style>